import React, { Component } from 'react'
import PropTypes from 'prop-types'

class SrcCardList extends Component {
  componentDidMount() {
    this.mountSrcCardList()
  }

  mountSrcCardList = async () => {
    await customElements.whenDefined('src-card-list')

    const srcCardList = document.getElementById('srcCardList')

    srcCardList.loadCards(this.props.cards)
    srcCardList.srcDigitalCardId = 'NONE'

    srcCardList.addEventListener('clickAddCardLink', this.handleAddCardClick)
    srcCardList.addEventListener('clickSignOutLink', this.handleSrcSignOut)
    srcCardList.addEventListener(
      'selectSrcDigitalCardId',
      this.handleSelectCard,
    )
  }

  componentWillUnmount() {
    const srcCardList = document.getElementById('srcCardList')

    srcCardList.removeEventListener('clickAddCardLink', this.handleAddCardClick)
    srcCardList.removeEventListener('clickSignOutLink', this.handleSrcSignOut)
    srcCardList.removeEventListener(
      'selectSrcDigitalCardId',
      this.handleSelectCard,
    )
  }

  handleSelectCard = event => {
    if (this.props.onSelectCard) {
      this.props.onSelectCard(event.detail)
    }
  }

  handleSrcSignOut = event => {
    if (this.props.onSrcSignOut) {
      this.props.onSrcSignOut(event)
    }
  }

  handleAddCardClick = event => {
    if (this.props.onAddCardClick) {
      this.props.onAddCardClick(event)
    }
  }

  render() {
    return (
      <src-card-list
        id="srcCardList"
        locale="pt_BR"
        card-brands="mastercard,visa"
        display-cancel-option="false"
        display-add-card="true"
        display-preferred-card="true"
        display-sign-out="true"
        card-selection-type="radioButton"
        src-digital-card-id="NONE"
        background="default"
      />
    )
  }
}

SrcCardList.propTypes = {
  cards: PropTypes.array.isRequired,
  onSelectCard: PropTypes.func,
  onAddCardClick: PropTypes.func,
  onSrcSignOut: PropTypes.func,
}

export default SrcCardList
